import { defer, propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export interface IDelayProps {
  closeDelay: number | string;
  openDelay: number | string;
}

export interface IUseDelay {
  clearDelay: () => void;
  runCloseDelay: () => Promise<unknown>;
  runOpenDelay: () => Promise<unknown>;
}

export const makeDelayProps = propsFactory(
  {
    /**
     * Задержка в миллисекундах перед закрытием оверлея. Только для события hover и focus.
     */
    closeDelay: {
      type: [Number, String] as PropType<number | string>,
      default: null
    },
    /**
     * Задержка в миллисекундах перед открытием оверлея. Только для события hover и focus.
     */
    openDelay: {
      type: [Number, String] as PropType<number | string>,
      default: null
    }
  },
  'delay'
);

export function useDelay(props: IDelayProps, cb?: (value: boolean) => void): IUseDelay {
  let clearDelay: () => void = () => {};

  function runDelay(isOpening: boolean) {
    clearDelay?.();

    const delay = Number(isOpening ? props.openDelay : props.closeDelay);

    return new Promise((resolve) => {
      clearDelay = defer(delay, () => {
        cb?.(isOpening);
        resolve(isOpening);
      });
    });
  }

  function runOpenDelay() {
    return runDelay(true);
  }

  function runCloseDelay() {
    return runDelay(false);
  }

  return {
    clearDelay,
    runOpenDelay,
    runCloseDelay
  };
}
